﻿'use strict';

/**
* Building Tabs.
*
* @param {mixed} [template] - The form template itself, as an array or object.
* @param {string} [templateUrl] - The URL to retrieve the form template from; template overrides.
* @param {Object} data - An object in the current scope where the form data should be stored.
* @example <tabs data="data"></form-builder>
*/
angular.module('ntmApp')
  .directive('tabs', ['$rootScope', function ($rootScope) {
      return {
          restrict: 'E',
          require: '?data',
          replace: 'true',
          templateUrl: 'ng1/src/directives/templates/tabs.html',
          scope: {
              data: '=',
              select: '='
          },
          link: function (scope) {
              var tabId = null;
              scope.tabs = angular.copy(scope.data);

              if ($rootScope.globals && $rootScope.globals.application) {
                  tabId = $rootScope.globals.application.id;
              } else {
                  tabId = scope.tabs[0].id;
              }

              function initTabs() {
                  scope.tabs.forEach(function (tab) {
                      if (tabId === tab.id) {
                          tab.open = true;
                      } else {
                          tab.open = false;
                      }
                  });
              }

              initTabs();

              scope.setTab = function ($event, id) {
                  $event.stopPropagation();
                  if (id) {
                      scope.select(id);
                  }
              };
          }
      };
  }]);